if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this._started) return;
      this._started = true;
      this.fetchRecommendations(this.dataset.url, false);
    }

    async fetchRecommendations(url, isRetry) {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const sectionId = this.dataset.sectionId;
        const sectionEl = doc.querySelector(`#shopify-section-${sectionId}`);
        const tiles = sectionEl
          ? Array.from(sectionEl.querySelectorAll('related-product'))
          : [];

        if (tiles.length === 0 && !isRetry) {
          const relatedUrl = url.replace('intent=complementary', 'intent=related');
          return this.fetchRecommendations(relatedUrl, true);
        }

        if (tiles.length > 0) {
          this.injectTiles(tiles, sectionId);
        }
      } catch (err) {
        console.error('[Related Products] Recommendations fetch failed:', err);
      }
    }

    async injectTiles(tiles, sectionId) {
      const relProdCarousel = document.querySelector(
        `related-products-carousel[data-section-id="${sectionId}"]`
      );
      const swiperEl = document.getElementById(`relprod-swiper-${sectionId}`);
      const gridEl = document.getElementById(`relprod-grid-${sectionId}`);

      if (!relProdCarousel || !swiperEl || !gridEl) return;

      const slideCards = [];

      tiles.forEach((tile, index) => {
        const tileClone = tile.cloneNode(true);
        const slide = document.createElement('swiper-slide');
        slide.appendChild(tileClone);
        swiperEl.appendChild(slide);

        const slideCard = tileClone.querySelector('.relprod-card');
        if (slideCard) slideCards.push(slideCard);

        const card = tile.querySelector('.relprod-card');
        if (!card) return;
        const cardClone = card.cloneNode(true);
        if (index >= 4) {
          cardClone.classList.add('hidden');
          cardClone.dataset.extraTile = '';
        }
        gridEl.appendChild(cardClone);
      });

      await customElements.whenDefined('swiper-container');
      if (swiperEl.swiper) {
        swiperEl.swiper.update();
      } else {
        swiperEl.initialize();
      }

      // Equalize card heights on desktop after layout is computed
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (!slideCards.length) return;
          const maxH = Math.max(...slideCards.map(c => c.getBoundingClientRect().height));
          if (maxH > 0) slideCards.forEach(c => { c.style.minHeight = maxH + 'px'; });
        });
      });

      if (tiles.length > 4) {
        const loadMoreBtn = relProdCarousel.querySelector('[data-relprod-load-more]');
        if (loadMoreBtn) loadMoreBtn.classList.remove('hidden');
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}

if (!customElements.get('related-products-carousel')) {
  class RelatedProductsCarousel extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._openRelProdModalId = null;

      window.addEventListener('click', (e) => {
        const opener = e.target.closest('[data-modal-action="open"][data-modal-id]');
        if (opener?.dataset.modalId?.startsWith('relprod-qb-')) {
          this._openRelProdModalId = opener.dataset.modalId;
        }
      });

      window.addEventListener('submit', (e) => {
        if (!this._openRelProdModalId) return;
        if (!e.target.closest('[data-modal-content^="relprod-qb-"]')) return;
        window.dispatchEvent(
          new CustomEvent('modal:closeById', { detail: this._openRelProdModalId })
        );
        this._openRelProdModalId = null;
      });

      const loadMoreBtn = this.querySelector('[data-relprod-load-more]');
      if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', () => this.loadMore());
      }
    }

    loadMore() {
      const grid = this.querySelector('[id^="relprod-grid-"]');
      if (!grid) return;

      const hidden = Array.from(grid.querySelectorAll('[data-extra-tile]'));
      hidden.slice(0, 4).forEach((tile) => {
        tile.classList.remove('hidden');
        delete tile.dataset.extraTile;
      });

      if (grid.querySelectorAll('[data-extra-tile]').length === 0) {
        const loadMoreBtn = this.querySelector('[data-relprod-load-more]');
        if (loadMoreBtn) loadMoreBtn.classList.add('hidden');
      }
    }
  }

  customElements.define('related-products-carousel', RelatedProductsCarousel);
}
